export type UnauthorizedReason = "session_expired" | "not_authorized";

let unauthorizedHandler: ((reason: UnauthorizedReason) => void) | null = null;

export function setUnauthorizedHandler(
  handler: ((reason: UnauthorizedReason) => void) | null,
) {
  unauthorizedHandler = handler;
}

export function notifyUnauthorized(
  reason: UnauthorizedReason = "session_expired",
) {
  unauthorizedHandler?.(reason);
}
